import React from "react";
import { PdfWrapper } from "@/components/abituriyent/pdf_download/style";

function PdfDownload({ link, text }) {
  // Fayldan nom olish
  const filename = link ? decodeURIComponent(link.split("/").pop()) : text || "Fayl";

  return (
    <PdfWrapper>
      <div className="container">
        <div className="pdf-box">
          <div className="left-content">
            {/* PDF icon */}
            <div className="pdf-icon-wrap">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="9" y1="15" x2="15" y2="15"/>
                <line x1="9" y1="11" x2="15" y2="11"/>
              </svg>
            </div>

            <div className="text-wrap">
              <span className="label">Hujjat</span>
              <span className="filename">{filename}</span>
            </div>
          </div>

          <a href={link} download target="_blank" rel="noopener noreferrer" className="right-pdf">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Yuklab olish
          </a>
        </div>
      </div>
    </PdfWrapper>
  );
}

export default PdfDownload;
